// removed by extract-text-webpack-plugin
module.exports = {"container":"container__YF6dX","flipPanel":"flipPanel__HC05E","panel":"panel__S3G5l","front":"front__1nKaL","back":"back__3LSlG","open":"open__1S_Nl","slide":"slide__KYgmA","slideContent":"slideContent__2K7E0","slideContent__image":"slideContent__image__1iwje","slideContent__title":"slideContent__title__aa5hc","slideContent__description":"slideContent__description__2CltF"};


//////////////////
// WEBPACK FOOTER
// ./components/spareparts/magazineGallery/style.less
// module id = SM8z
// module chunks = 75